export const scrollBy = (elementId, extra = 0) => {
  const elementPos = getPosition(document.getElementById(elementId)),
    wrapper = document.getElementById("root-wrapper"),
    to = elementPos.y + extra;

  wrapper.scrollTop = to;
};

function getPosition(el) {
  var xPos = 0;
  var yPos = 0;

  while (el) {
    xPos += el.offsetLeft;
    yPos += el.offsetTop;
    el = el.offsetParent;
  }

  return {
    x: xPos,
    y: yPos
  };
}



// WEBPACK FOOTER //
// ./src/actions/scroll.js